import {paramCase} from 'change-case'

window.__TEST__ = true
window.appName = process.env.REACT_APP_APP_NAME || 'Familybiz Planners Admin'
window.programmaticAppName = paramCase(window.appName)
